import type { ISchemaMeta } from '$shared/interfaces/api/ISchemaMeta';
import BaseModel from '$shared/models/BaseModel';

export class SchemaMeta extends BaseModel<ISchemaMeta> {
  declare public value: string;
  declare public description: string;

  public setDescription(description: string): void {
    this.description = description;
  }

  public toCommonList(): CommonList {
    return {
      id: this.value,
      label: this.description || this.value
    };
  }

  protected transformResponse(): void {
    this.value = this.response?.value;
    this.description = this.response?.description || '';
  }
}
